import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { localizeDate } from '../utilsDesign';
import { Avatar } from './Avatar';
import { LangContext } from '../../contexts/langContext';
import { CelebsContext } from '../../contexts/celebsContext';
import { ChatStateContext } from '../../contexts/chatStateContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { convertGMTtoDateTime } from '../utilsDesign';
import { _getCity } from '../utilsGeo';
import { AvatarName } from './AvatarName';
import { Button } from './Button';
import { CityDateTime } from './CityDateTime';
import { DropDown } from './DropDown';
import { EditName } from './EditName';
import { Icon } from './Icon';
import { Preloader, PreloaderButton } from './kit';
import { Date } from './StringDateTime';
import { PopoverH, TooltipH } from './TooltipH';
import { AUTH_MODAL_SIGNUP, openAuth } from '../utilsAuth';


const dobClock = (dob) => {
  if (!dob) return '';
  return convertGMTtoDateTime(dob, 0)?.time || '';
};

const avatarTimeLabel = (avatar) => {
  const start = dobClock(avatar?.dob_start);
  const end = dobClock(avatar?.dob_end);
  if (start && end) return start === end ? start : `${start}–${end}`;
  return dobClock(avatar?.dob);
};

const handleCloseInfoPop = (e, path, context, navigate, location) => {
  if (!e.target.classList.contains('x_click_pop')) {
    document.body.classList.remove('noscroll');
    context.setState.setHighlighted()
    context.setState.setSearch([])

    const removeStudySegments = (pathname) => {
      const segments = pathname.split('/study')
      return segments.length > 1 ? segments[0] : null
    };
    const currentPath = location.pathname.replace(/\/$/, '');
    const newPath = removeStudySegments(currentPath);
    const queryParams = location.search ? location.search.replace(/\/$/, '') : '';
    if (path && path.startsWith('/')) {
      navigate(path)
    } else if (newPath) {
      const suffix = path ? `/${path}` : '';
      navigate(`${newPath}${queryParams}${suffix}`)
    } else if (path) {
      navigate(`${path}`)
    }
  } else if (path) {
    navigate(`${path}`)
  }
};


export function AvatarPanel(props) {
  const {
    mode = 'hd',
    publ,
    user,
    avatar = {},
    followings = [],
    followers = [],
    refetch = () => void (0),
    children
  } = { ...props };
  const navigate = useNavigate();
  const context = {
    ...useContext(SocialContext),
    ...useContext(StateContext),
    ...useContext(LangContext),
    ...useContext(CelebsContext)
  }
  const $ui = context.$ui;

  const [city, setCity] = useState()
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [isEditingName, setIsEditingName] = useState(false);

  useEffect(() => {
    setCity()
  }, [avatar.city_id])

  const [avatarInner, setAvatarInner] = useState(avatar)

  useEffect(() => {
    // Don't clobber an in-progress name edit; otherwise keep local
    // avatar in sync (design arrives after first calculate, etc.).
    if (isEditingName) return
    if (
      avatar.token !== avatarInner.token
      || avatar.name !== avatarInner.name
      || avatar.dob !== avatarInner.dob
      || avatar.design?.id !== avatarInner.design?.id
      || avatar.city_id !== avatarInner.city_id
    ) {
      setAvatarInner(avatar)
    }
  }, [avatar, isEditingName])

  const isCeleb = user
    && context.celebs
    && Object.keys(context.celebs).filter(celebId => celebId === user.token).length;


  const getGMTwithSign = (offset) => offset ? `GMT${offset >= 0 ? `+${offset}` : offset}` : '';

  const location = useLocation();





  return (
    <>
      <div className="x_0_user"
      >


        <div className="x_0_user_block">

          <div className="x_calc_result_name0">
            <div className="x_calc_result_name"
            // onClick={() => avatar.my && navigate('info')}
            >

              {mode === 'hd' && <Avatar
                avatar={avatar}
                type='calc'
              />}

              <div className="x_calc_sticky">



                {!user && avatar.my &&
                  <TooltipH
                    // color={'#f4f4f4'}
                    // tip={'#f4f4f4'}
                    update={avatarInner.name}
                    fresh
                    placement='bottom'
                    open={tooltipOpen}
                    onOpenChange={(open) => {
                      // Не закрываем тултип, если пользователь редактирует имя
                      if (!open && isEditingName) {
                        return;
                      }
                      setTooltipOpen(open);
                    }}
                    title={<EditName
                      name={avatarInner.name}
                      onEditingChange={setIsEditingName}
                      handleUpdate={(newName) => {
                        setTooltipOpen(false);
                        setIsEditingName(false);
                        setAvatarInner({ ...avatarInner, name: newName });
                        context.x.updateAvatar({
                          'token': avatar.token,
                          'name': newName
                        }, (newAva) => {
                          setAvatarInner(newAva);
                        })
                      }}
                    />}>
                    <div className="x_calc_result_title ellipsis">
                      <AvatarName avatar={avatarInner} />
                    </div>
                  </TooltipH>
                }

                {user && avatar.my &&
                  <div className="x_calc_result_title ellipsis"
                    onClick={(e) => {
                      handleCloseInfoPop(e, 'info', context, navigate, location)
                    }}
                  >
                    <AvatarName avatar={avatarInner} />
                  </div>
                }

                {!avatar.my && <div className="x_calc_result_title x_calc_result_title--inactive ellipsis"
                //TODO: когда публичный
                // onClick={() => navigate('info')}
                >
                  <AvatarName avatar={avatarInner} />
                </div>}



              </div>

            </div>


          </div>



          {Boolean(context.me) && <UserSocialLine
            mode={mode}
            user={user}
            avatar={avatar}
            refetch={refetch}
            followers={followers}
            followings={followings}
            publ={publ}
          />}

        </div>

        <div className="x0_search">
          <CityDateTime
            key={avatar.token}
            // publ={false}
            avatar={avatar}
            citySearchActive={context.state.citySearchActive}
            updatingAva={context.updatingAva}
            showForm={
              context.state.calcShown
              && !context.updatingAva
              || (
                avatar.design.id === 'dummy'
                && avatar.my
              )
            }
            updateHandler={context.x.updateAvatar}
            setShowForm={(val) => context.setState.setCalcShown(val)}
          // avatarDate={avatar.dob && city ? convertGMTtoDateTime(avatar.dob)['date'] : null}
          // avatarTime={avatar.dob && city ? convertGMTtoDateTime(avatar.dob)['time'] : null}
          // avatarOffset={city && city.offset ? city.offset : null}
          // avatarCityId={avatar.city_id ? avatar.city_id : null}
          // dob={avatar.dob}
          // city={city}
          />
        </div>


        {/* {(user || avatar.my) && <AvatarDob
          publ={publ}
          avatar={avatar}
        />}

        {(!user && !avatar.my && publ) && <PublicDob
          avatar={avatar}
        />} */}








      </div>







    </>
  )
}


export function AvatarDob(props) {
  const {
    children,
    publ,
    user,
    avatar = {},
    penta,
    showInfo = true,
  } = { ...props };
  const navigate = useNavigate();
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext), ...useContext(CelebsContext) };
  const $ui = context.$ui;

  let urlParams = new URLSearchParams(window.location.search);
  const cityName = urlParams.get('city') ? urlParams.get('city') : '';

  const [city, setCity] = useState()

  useEffect(() => {
    if ((city && city.id !== avatar.city_id) || !avatar.city_id) {
      setCity()
    }
  }, [avatar.city_id])

  const location = useLocation();



  useEffect(() => {
    if ((avatar.city_id && !city)) {
      if (avatar.aggr && avatar.aggr.city) {
        setCity(avatar.aggr.city)
      } else {
        //TODO: город возвращается даже если поменялся урл и в итоге проставляет не тот город
        // _getCity(avatar.city_id, setCity)
      }
    }
  })

  useEffect(() => {
    // console.log('city = ', city);
  }, [city])


  // const [followersQ, setFollowersQ] = useState(followers.length)

  // useEffect(() => {
  //   if (followers.length !== followersQ) {
  //     setFollowersQ(followers.length)
  //   }
  // }, [followers])


  const getGMTwithSign = (offset) => offset ? `GMT${offset >= 0 ? `+${offset}` : offset}` : '';

  // const hideYear = true;

  const isCeleb = user
    && context.celebs
    && Object.keys(context.celebs).filter(celebId => celebId === user.token).length;

  let hideYear = !avatar.my || !context.me;
  hideYear = isCeleb ? false : hideYear;
  hideYear = !user ? false : hideYear;
  hideYear = !context.me && penta ? true : hideYear;
  // const hideYear = !avatar.my && user.token && context.me;
  // console.log('!avatar.my = ', !avatar.my);
  // console.log('user = ', user);

  return (
    <>





      {Boolean(avatar.dob) && <div
        className={avatar.my ? `${context.state.calcShown ? "x_toggles_li" : "x_toggles_li "}` : "x_toggles_li x_toggles_li--locked"}
        onClick={(e) => {
          handleCloseInfoPop(e, null, context, navigate, location)
          avatar.my && context.setState.setCalcShown(true)
        }}
      // style={{ opacity: context.state.calcShown ? 0 : 1, zIndex: 11000 }}
      >

        {showInfo && <UTCinfo avatar={avatar} hideYear={hideYear} />}


        <div className="x_calc_result_bio_1">

          {/* <div className="x_calc_result_bio_line x_calc_result_bio_line--label">
              {$ui('birth_data')}:
            </div> */}
          {Boolean(avatar.dob) && <div className="x_calc_result_bio_line  ellipsis">
            {`${localizeDate(convertGMTtoDateTime(avatar.dob, null, 'date'), context.lang, hideYear)}`}
          </div>}

          {Boolean(avatar.dob) && city && avatarTimeLabel(avatar) && <div className="x_calc_result_bio_line">
            {` ${avatarTimeLabel(avatar)}`}
          </div>}

          {!hideYear && <>
            {(city || Boolean(cityName)) && <div className="x_calc_result_bio_line ellipsis">
              {city && `${city.city}, ${city.country}`}
              {!city && cityName}
            </div>}
            {city && Boolean(avatar.city_id) && avatar.design?.utc && <div className="x_calc_result_bio_line x_calc_result_bio_line--label  ellipsis">
              {getGMTwithSign(avatar.design.utc)}
            </div>}
          </>}

          {hideYear && <>
            {(city || Boolean(cityName)) && <div className="x_calc_result_bio_line ellipsis">
              {city && `${$ui('timezone')}: ${city.timezone}`}
            </div>}
          </>}


          {/* <div className="x_calc_result_bio_line">{avatar.city_id && city && getGMTwithSign(city.offset)}</div> */}

        </div>

      </div>}




      {/* <div className="x_calc_result0">
          <CityDateTime
            publ={publ}
            avatar={avatar}
            // showForm={context.state.calcShown}
            // setShowForm={(val) => context.setState.setCalcShown(val)}
            avatarDate={avatar.dob && city ? convertGMTtoDateTime(avatar.dob)['date'] : null}
            avatarTime={avatar.dob && city ? convertGMTtoDateTime(avatar.dob)['time'] : null}
            avatarOffset={city && city.offset ? city.offset : null}
            avatarCityId={avatar.city_id ? avatar.city_id : null}
            dob={avatar.dob}
            city={city}
        />
      </div> */}

    </>

  )
}



export const UTCinfo = ({ avatar, children, hideYear = true }) => {
  return <TooltipH
    mobileOff
    // color={'white'} key={'white'}
    // overlayInnerStyle={{ color: 'black', }}
    mouseEnterDelay={0}
    title={<>{avatar.dob && <>
      <div className="_fv _fgap0">


        <div className="">
          <span className='x_calc_label'>Birth date:</span> <span><Date date time hideYear={hideYear}>{avatar.dob}</Date></span>
        </div>
        <div className="">
          <span className='x_calc_label'>UTC:</span> <Date date time hideYear={hideYear}>{avatar.design?.meta?.personality}</Date><br />
        </div>
        <div className="">
          <div className="_fv _fgap0">
            <div>
              <span className='x_calc_label'>Design:</span> <Date date time hideYear={hideYear}>{avatar.design?.meta?.design}</Date>
            </div>
            <div>
            </div>
          </div>
        </div>
      </div>
    </>}
    </>}
  >
    {!children && <div>
      <Icon>info</Icon>
    </div>}

    {children}
  </TooltipH>
}




export function PublicDob(props) {
  const {
    children,
    user = {},
    avatar = {},
    noClick = false,
    showInfo = true,
  } = { ...props };
  const navigate = useNavigate();
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext), ...useContext(CelebsContext) };
  const $ui = context.$ui;


  let urlParams = new URLSearchParams(window.location.search);
  const cityName = urlParams.get('city') ? urlParams.get('city') : '';
  const timezone = urlParams.get('timezone') ? urlParams.get('timezone') : 'GMT';
  const offset = urlParams.get('offset') ? urlParams.get('offset') : 0;


  const [city, setCity] = useState()

  useEffect(() => {
    if (avatar.city_id) {
      _getCity(avatar.city_id, setCity)
    } else {
      setCity()
    }
  }, [avatar])

  useEffect(() => {
    // console.log('city = ', city);
  }, [city])

  const location = useLocation();



  const getGMTwithSign = (offset) => offset ? `GMT${offset >= 0 ? `+${offset}` : offset}` : '';

  return (
    <>



      <div
        className={avatar.my ? `${context.state.calcShown ? "x_toggles_li" : "x_toggles_li "}` : "x_toggles_li x_toggles_li--locked"}
        style={{ pointerEvents: noClick ? 'none' : 'auto' }}
        onClick={(e) => {
          handleCloseInfoPop(e, null, context, navigate, location)
          avatar.my && context.setState.setCalcShown(true)
        }}
      // style={{ opacity: context.state.calcShown ? 0 : 1, zIndex: 11000 }}
      >

        {Boolean(avatar.dob) && showInfo && <UTCinfo avatar={avatar} hideYear={false} />}


        {Boolean(avatar.dob) && <div className="x_calc_result_bio_1">

          {/* <div className="x_calc_result_bio_line x_calc_result_bio_line--label">
              {$ui('birth_data')}:
            </div> */}
          {Boolean(avatar.dob) && <div className="x_calc_result_bio_line">
            {`${localizeDate(convertGMTtoDateTime(avatar.dob, null, 'date'), context.lang, false)}`}
          </div>}
          {avatar.dob && city && avatarTimeLabel(avatar) && <div className="x_calc_result_bio_line">
            {` ${avatarTimeLabel(avatar)}`}
          </div>}
          <div className="x_calc_result_bio_line ellipsis">
            {cityName}&nbsp;&nbsp;{timezone}
          </div>

        </div>}


      </div>



    </>
  )
}



export const UserSocialLine = ({
  publ,
  user,
  avatar = {},
  refetch,
  followers = [],
  followings = [],
  vertical,
  mode = 'hd'
}) => {
  const navigate = useNavigate();
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext), ...useContext(CelebsContext) }
  const chatState = useContext(ChatStateContext);
  const $ui = context.$ui;
  let urlParams = new URLSearchParams(window.location.search);

  const isMe = Boolean(context.me) && (avatar.token === context.me.avatar.token);
  const isCeleb = context.celebs && Boolean(user && context.celebs && Object.keys(context.celebs).filter(celebId => celebId === user.token).length);

  // const [followingsLength, setFollowingsLength] = useState(user ? user.aggr.followings_count : '')
  // const [followersLength, setFollowersLength] = useState(user ? user.aggr.followers_count : '')

  const location = useLocation();


  useEffect(() => {

    if (user) {
      const fetchDataAsync = async (what, callback = () => void (0)) => {
        // setLoading(true);
        try {
          const data = await context.x.getUserSocial(user.token, what, 'length');
          callback(data);
        } catch (error) {
          console.error("Fetching data failed:", error);
          // setError(error);
        } finally {
          // setLoading(false);
        }
      };

      // fetchDataAsync('followings', setFollowingsLength);
      // fetchDataAsync('followers', setFollowersLength);
    }
  }, [user]);


  return <div className={vertical ? "x_0_user_social0 x_0_user_social0--h" : "x_0_user_social0"}>



      {isMe
        && !isCeleb
        && <div className="x_0_user_followbutton">

          {(!(user && user.city_id)
            || !avatar.name
            || !avatar.image
          )
            && <div className="x_noti0" />}

          <div className="x_button x_button--ghost"
            onClick={(e) => {
              handleCloseInfoPop(e, context.me ? 'info' : '', context, navigate, location)
            }}
          >
            {!(user && user.city_id) && <div className="x_noti0" />}
            {$ui('but_edit_profile')}
          </div>
        </div>}


      {/* {!isMe && <div className="x_0_user_followbutton">

      {(!(user && user.city_id)
        || !avatar.name
        || !avatar.image
      )
        && <div className="x_noti0" />}

      <div className="x_button x_button--ghost"
        onClick={() => context.me ? navigate('info') : void (0)}
      >
        {!(user && user.city_id) && <div className="x_noti0" />}
        {$ui('but_edit_profile')}
      </div>
    </div>} */}



      {!user
        && !context.me
        && !avatar.my
        && !isCeleb
        && <>
          {mode === 'hd' && <div className="x_0_user_followbutton">
            <a
              href='/auth0/login'
              className="x_button x_button--ghost"
              onClick={openAuth(context.setState.setAuthModal, AUTH_MODAL_SIGNUP)}
            >
              {$ui('but_follow_unlog')}
            </a>
          </div>}
          {mode === 'yoni' && <div className="x_0_user_followbutton">
            <a
              href='/auth0/login'
              className="x_button x_button--ghost"
              onClick={openAuth(context.setState.setAuthModal, AUTH_MODAL_SIGNUP)}
            >
              {/* {$ui('but_follow_unlog')} */}
            </a>
          </div>}
        </>}


      {/* {!user && avatar.my && <>
      <div className="x_0_user_followbutton">
        <div className="x_button x_button--ghost"
          onClick={() => navigate('info')}
        >
          <Icon>edit</Icon>  {$ui('but_edit_avatar')}
        </div>
      </div>
    </>} */}









      {
        user
        && context.followings
        && !context.x.checkIfFollow(user.token)
        && !isCeleb
        && !isMe
        && <div className="x_0_user_followbutton">

          {!context.followingUser.includes(user.token) &&
            <TooltipH
              title={$ui('but_follow')}
              mobileOff
            >
              <div className="x_button"
                onClick={() => {
                  context.x.follow({ user },
                    () => refetch(user.token)
                    // setFollowersQ(prev => prev + 1)
                  )
                }}
              >
                <Icon button>person_add</Icon>
                {/* {$ui('but_follow')} */}
                {/* <Icon>check</Icon> */}
              </div></TooltipH>}

          {context.followingUser.includes(user.token) && <div className="x_button x_button--ghost">
            <PreloaderButton><Preloader size={16} /></PreloaderButton>
            {/* <div style={{ visibility: 'hidden' }}>{$ui('but_follow')}</div> */}
          </div>}

        </div>}




      {user
        && !publ
        && !user.isMe
        && context.me
        && avatar.design['id'] !== 'dummy'
        && <Button
          icon='electric_bolt'
          onClick={(e) => {
            const base = mode === 'yoni' ? '/yoni/p' : '/p';
            handleCloseInfoPop(e, `${base}/${context.me.user.token}-${user.token}`, context, navigate, location)
          }}
          // tooltip={$ui('penta_composite')}
          tooltipMobileOff
        // tooltipPlacement='bottom'
        >
          {$ui('penta_composite')}
        </Button>}





      <>
        {
          user
          && context.me
          && !isMe
          && !isCeleb
          && <Button
            // ghost
            icon='mail'
            onClick={(e) => {
              handleCloseInfoPop(e, null, context, navigate, location)
              chatState.setCurrentChat(user.token)
            }}
          >
            {/* {$ui('but_following')} */}
            {/* {$ui('chat_send_message')} */}
          </Button>}

        {user && !context.me && <Button
          icon='mail'
          disabled
        // onClick={() => chatState.setCurrentChat(user.token)}
        >
          {/* {$ui('but_following')} */}
          {/* <Icon button>mail</Icon> */}
          {/* {$ui('chat_send_message')} */}
        </Button>}


      </>



      {!user
        && !publ
        && !avatar.isMe
        && context.me
        && avatar.design['id'] !== 'dummy'
        && <Button
          icon='electric_bolt'
          onClick={(e) => {
            const base = mode === 'yoni' ? '/yoni/p' : '/p';
            handleCloseInfoPop(e, `${base}/${context.me.user.token}-${avatar.token}`, context, navigate, location)
          }}
          // tooltip={$ui('penta_composite')}
          tooltipMobileOff
        >
          {$ui('penta_composite')}
        </Button>}



        {!user
        && avatar.my
        && avatar.design['id'] !== 'dummy'
        && <>
          <div className="x_0_user_followbutton">
            <Button
              ghost
              icon='qr_code'
              onClick={(e) => {
                handleCloseInfoPop(e, 'info', context, navigate, location)
              }}
            >
              {$ui('but_invite')}
            </Button>
          </div>
        </>}



      <div className="_f _fgap02">



        {!vertical
          && user
          && !isCeleb
          && <>
            <div className="x_0_user_followers">


              <div className="x_0_user_followcount">


                <Button
                  ghost
                  icon='hub'
                  // tooltip={`${$ui('but_following')} / ${$ui('but_followers')}`}
                  // tooltipMobileOff
                  onClick={(e) => {
                    handleCloseInfoPop(e, 'followers', context, navigate, location)
                  }}
                >
                  <strong>{user.aggr.followings_count}</strong> <span className='_o02'>/</span> <strong className='_o04'>{user.aggr.followers_count} </strong>
                </Button>
              </div>



            </div>
          </>}

        {user
          && !isMe
          && !isCeleb
          && context.followings
          && context.x.checkIfFollow(user.token)
          && <div className="x_0_user_followbutton">


            {/* {!context.followingUser.includes(user.token) && <>
          <DropDown
            id={avatar.token}
            options={[
              {
                icon: 'person_remove',
                title: $ui('but_unfollow'),
                handle: () => context.x.unfollow({ user },
                  () => refetch(user.token)
                  // setFollowersQ(prev => prev - 1)
                )
              }
            ]}
          >
              <Button ghost icon='expand_more'>
                <Icon button>group</Icon>
              </Button>
          </DropDown>
        </>} */}



            {!context.followingUser.includes(user.token) && <>
              <PopoverH
                title={<div className='_fv _gap02'>

                  {user
                    && !user.isMe
                    && context.me
                    && <Button
                      className='_f100'
                      ghost
                      sm
                      onClick={(e) => {
                        handleCloseInfoPop(e, `info`, context, navigate, location)
                      }}
                      icon='qr_code'
                      tooltip={$ui('but_public_link_short')}
                      tooltipMobileOff
                    >{$ui('but_public_link_short')}</Button>}


                  <Button
                    className='_f100'
                    icon="person_remove"
                    red
                    sm
                    onClick={() => context.x.unfollow({ user },
                      () => refetch(user.token)
                      // setFollowersQ(prev => prev - 1)
                    )}
                  >{$ui('but_unfollow')}</Button></div>}
                placement='bottom'>
                <Button ghost icon='expand_more' />
              </PopoverH></>}


            {context.followingUser.includes(user.token) && <>
              <div className="x_button x_button--ghost" icon='expand_more'>
                <PreloaderButton><Preloader size={16} /></PreloaderButton>
                <div style={{ visibility: 'hidden' }}>{$ui('but_following')}</div>
              </div>
            </>}


          </div>}


    </div>




    {isCeleb &&
      <TooltipH title={$ui('people_celeb_tooltip')} placement='bottom' mobileOff>
        <div className="x_button x_button--flat">
          <div className>
            <span style={{ transform: 'none' }}>
              <span className="t_icon  ">star</span></span>
          </div>
        </div>
      </TooltipH>}






  </div>
}